import React from 'react';
import {
  Container,
  Typography,
  ImageList,
  ImageListItem,
  useMediaQuery,
  useTheme,
} from '@mui/material';

const totalGalleryImages = 24; // Update this based on how many images you have

const galleryImages = Array.from({ length: totalGalleryImages }).map((_, idx) => ({
  src: `/images/SJ_Gallery/showcase/gallery${idx + 1}.webp`, // e.g., gallery1.jpg, gallery2.jpg
  alt: `SJ Swimming Gallery Image ${idx + 1}`,
}));

const Gallery = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));      // <600px → 1 col
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600–900px → 2 cols


  let columns = 3;
  if (isMobile) columns = 1;
  else if (isTablet) columns = 2;
  return (
    <Container sx={{ mt:4, mb: 6 }}>
      <Typography
        variant="h1"
        sx={{
          textAlign: 'center',
          mb: 4,
          color: theme.palette.primary.main,
        }}
      >
        Gallery
      </Typography>

      <Typography variant="body1" sx={{ textAlign: 'center', mb: 5 }}>
        A glimpse into our classes, squads, and special moments at SJ Swimming.
      </Typography>

      <ImageList variant="masonry" cols={columns} gap={16}>
        {galleryImages.map((item, index) => (
          <ImageListItem key={index}>
            <img
              src={item.src}
              alt={item.alt}
              loading="lazy"
              style={{
                borderRadius: 8,
                width: '100%',
                display: 'block',
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Container>
  );
};

export default Gallery;